import {createStore} from "redux";
import {createRootReducer} from "../reducers";

export interface IAction {
    type: string,
    payload?: any
}

// display actions
export const CHANGE_COLUMNS = 'CHANGE_COLUMNS'
export const CHANGE_CONTENT_FONT = 'CHANGE_CONTENT_FONT'
export const CHANGE_HEADER_FONT = 'CHANGE_HEADER_FONT'
export const CHANGE_LOCATIONS = 'CHANGE_LOCATIONS'
export const CHANGE_COMP = 'CHANGE_COMP'
export const TOGGLE_INCLUDE_UNRECOGNIZED_CHIPS = 'TOGGLE_INCLUDE_UNRECOGNIZED_CHIPS'

// auth actions
export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN'
export const SET_USER_NAME = 'SET_USER_NAME'

const store = createStore(createRootReducer());
export default store